export default "__VITE_ASSET__5a1a25fb__"